import PriceTag from 'components/PriceTag'
import useAuctionCountdown from 'hooks/useAuctionCountdown'
import type { NFDAuctionAndPrice } from 'api/api-client'

interface AuctionPriceProps {
  auction: NFDAuctionAndPrice
  className?: string
}

export default function AuctionPrice({ auction, className = '' }: AuctionPriceProps) {
  const { timer, price } = useAuctionCountdown(auction)

  const { hours, minutes, seconds } = timer
  const showPrice = hours + minutes + seconds <= 0 ? auction.auctionInfo.floorPrice : price

  return <PriceTag price={showPrice} className={className} />
}
